var map = {
	"./circle-user.svg": 86044,
	"./communication.svg": 12824,
	"./hourglass.svg": 94298,
	"./starburst.svg": 44326,
	"./tech.svg": 14692,
	"./user-pen.svg": 79715,
	"./user-plus.svg": 78846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92904;